import { useRef } from 'react';
import { Button } from '@shared/components';
import { Check, Plus } from 'lucide-react';

interface AddOnCardActionsProps {
    addOnName: string;
    formId: string;
    isAdding: boolean;
    canConfirm: boolean;
    onStart: () => void;
    onConfirm: () => void;
    onCancel: () => void;
}

export function AddOnCardActions({
    addOnName,
    formId,
    isAdding,
    canConfirm,
    onStart,
    onConfirm,
    onCancel,
}: AddOnCardActionsProps) {
    const primaryRef = useRef<HTMLDivElement>(null);

    const handleCancel = () => {
        onCancel();
        primaryRef.current?.querySelector('button')?.focus();
    };

    return (
        <div className="flex items-center gap-2">
            {isAdding && (
                <Button type="button" variant="outline" size="sm" onClick={handleCancel}>
                    Cancel
                </Button>
            )}
            <div ref={primaryRef}>
                <Button
                    type="button"
                    size="sm"
                    startIcon={isAdding ? <Check size={18} /> : <Plus size={18} />}
                    ariaLabel={isAdding ? `Confirm ${addOnName}` : `Add ${addOnName}`}
                    ariaExpanded={isAdding}
                    ariaControls={isAdding ? formId : undefined}
                    ariaDisabled={isAdding && !canConfirm}
                    onClick={isAdding ? onConfirm : onStart}
                >
                    {isAdding ? 'Confirm' : 'Add'}
                </Button>
            </div>
        </div>
    );
}
